import PropTypes from 'prop-types';
import { PureComponent } from 'react';
import styled from 'styled-components';
import { DRAG_ICON_BACKGROUND_COLOR, DRAG_ICON_INVALID_BACKGROUND_COLOR, DRAG_ICON_INVALID_ICON_OPACITY } from './constants';
import { jsx as _jsx } from "react/jsx-runtime";
const IconWrapper = styled.div.withConfig({
  displayName: "DragPreviewIconWrapper__IconWrapper",
  componentId: "sc-1juqyoi-0"
})([".hs-private.hs-private.hs-private &{padding:10px;background:", ";border-radius:3px;display:inline-flex;align-items:center;justify-content:center;vertical-align:middle;opacity:", ";}"], props => props.isValidDropZone ? props.backgroundColor : props.invalidBackgroundColor, props => props.isValidDropZone ? 1 : DRAG_ICON_INVALID_ICON_OPACITY);
class DragPreviewIconWrapper extends PureComponent {
  render() {
    const {
      backgroundColor,
      children,
      invalidBackgroundColor,
      isValidDropZone
    } = this.props;
    return /*#__PURE__*/_jsx(IconWrapper, {
      backgroundColor: backgroundColor,
      invalidBackgroundColor: invalidBackgroundColor,
      isValidDropZone: isValidDropZone,
      children: children
    });
  }
}
DragPreviewIconWrapper.defaultProps = {
  backgroundColor: DRAG_ICON_BACKGROUND_COLOR,
  invalidBackgroundColor: DRAG_ICON_INVALID_BACKGROUND_COLOR,
  isValidDropZone: true
};
DragPreviewIconWrapper.propTypes = {
  backgroundColor: PropTypes.string.isRequired,
  children: PropTypes.node.isRequired,
  invalidBackgroundColor: PropTypes.string.isRequired,
  isValidDropZone: PropTypes.bool.isRequired
};
export default DragPreviewIconWrapper;